import { render, staticRenderFns } from "./ForwardShipForm.vue?vue&type=template&id=5cf778d6&scoped=true"
import script from "./ForwardShipForm.vue?vue&type=script&lang=js"
export * from "./ForwardShipForm.vue?vue&type=script&lang=js"
import style0 from "./ForwardShipForm.vue?vue&type=style&index=0&id=5cf778d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf778d6",
  null
  
)

export default component.exports